import { NemRegions } from "../config";

export interface IntervalRecord {
	dateTime: Date;
	price: number;
	cumulativePrice: number;
	regionId: string;
	isActual: boolean;
}

export function mapApiDataToIntervals(apiData: any[]): IntervalRecord[]  {
	return apiData.map((d) => ({ dateTime: new Date(d.DT), price: d.P, cumulativePrice: d.CP, regionId: d.R, isActual: d.A === 1 }));
}

export function setForecastIntervals(apiData: IntervalRecord[]): IntervalRecord[] {
	let data: IntervalRecord[] = [];

	for (let regionId of NemRegions.map(r => r.value)) {
		let regionApiData: IntervalRecord[] = apiData.filter(d => d.regionId === regionId);

		// copy across actual intervals as is
		let regionData: IntervalRecord[] = regionApiData.filter(d => d.isActual);

		// append forecast intervals, expanding each 30 minute interval into six 5 minute intervals
		let lastActualDateTime: Date = regionData[regionData.length - 1].dateTime;
		for (let row of regionApiData.filter(d => !d.isActual)) {
			for (let minutes of [-25, -20, -15, -10, -5]) {
				let newForecastDateTime = new Date(row.dateTime.getTime() + minutes * 60000);
				if (newForecastDateTime.getTime() > lastActualDateTime.getTime()) {
					regionData.push({ ...row, dateTime: newForecastDateTime });
				}
			}
			regionData.push(row);
		}

		// calculate cumulative price for 5 minute forecast intervals
		for (let i = regionData.findIndex(d => !d.isActual); i < regionData.length; i++) {
			regionData[i].cumulativePrice = 0;
			for (let j = Math.max(0, i - 2015); j <= i; j++) { // should always be 2015 previous reads, but Math.max to avoid crashing if there isn't
				regionData[i].cumulativePrice += regionData[j].price;
			}
		}

		data.push(...regionData);
	}

	return data;
}



// WEBPACK FOOTER //
// src/views/electricity/nem/cumulative-price-common.ts